import { FeatureNotificationEnum } from '@portals/api/ui';
import { lazyNamedImport } from '@portals/utils';

export const FEATURES_MAP = {
  [FeatureNotificationEnum.FourteenDaysTrial]: lazyNamedImport(
    () => import('./features-modals/FourteenDaysTrial'),
    'FourteenDaysTrial'
  ),
} as const;
